<template>
  <div>
    <CompanySurvey2022 />
  </div>
</template>

<script>
import CompanySurvey2022 from "@/components/CompanySurvey2022.vue";
import FullPageLayout from "../layouts/FullPageLayout";

export default {
  components: {
    CompanySurvey2022
  },
  created() {
    this.$emit(`update:layout`, FullPageLayout);
  }
};
</script>
